<template>
  <div class="multipleChoiceSharingMenuRow">
    <span
      class="menu_container"
      :class="isOpenMenu ? 'menuIsOpenState' : ''"
      :style="{
        width: isOpenMenu ? baseOpt.openMenuWidthVw : baseOpt.closeMenuWidthVw,
      }"
    >
      <span class="menuBox_openBtn" @click="clickIsOpenMenu(isOpenMenu)">
        <svg
          t="1709202440753"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4668"
          width="60%"
          height="60%"
        >
          <path
            d="M242.005 1000.334c-29.013-27.875-28.444-74.524 0-102.969L627.485 512l-385.48-385.365c-28.444-28.445-28.444-74.525 0-102.97s74.525-28.444 102.97 0l437.02 436.907c15.587 13.768 38.912 61.327 0 102.97l-437.02 436.906c-20.595 21.732-67.243 34.247-102.97-0.114z"
            p-id="4669"
          ></path>
        </svg>
      </span>
      <span
        class="menuList"
        v-if="list && list.length > 0"
        :style="{ width: `calc(${baseOpt.openMenuWidthVw} - 3vw)` }"
      >
        <span
          class="menuItem"
          :class="isOpenMenu ? '' : 'hideMenu'"
          v-for="item in list"
          :key="item.id"
          @click="clickMenu(item)"
        >
          <span class="item_absChoose" :class="item.isAct ? 'chooseAct' : ''">
            <span class="checkbox_item">
              <svg
                t="1693726421166"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="21127"
                width="80%"
                height="80%"
              >
                <path
                  d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                  p-id="21128"
                ></path>
              </svg>
            </span>
          </span>
          <span class="menuItem_title" v-text="item.name"></span>
        </span>
      </span>
      <span class="theme_publishBtn" @click="clickPublicTheme()">
        <svg
          t="1692698307306"
          class="publishBtn_icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9670"
          width="80%"
          height="80%"
        >
          <path
            d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
            p-id="9671"
          ></path>
        </svg>
      </span>
    </span>
    <Popup
      v-if="popupShow"
      :closeEvent="closePopup"
      :popTitle="popTitle"
      :popOpraBtns="popOpraBtns"
      :contentWidth="contentWidth"
    >
      <template #webmaster_popup>
        <!-- 合成锦集 -->
        <div class="group_popup">
          <div class="group_popup_wraning">
            您还未选择
            <span v-text="popupDynameVal ? popupDynameVal : ''"></span>
            ，请选择后再次尝试
          </div>
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
// 单行的多选分享菜单 【案例：晋级图等】
import Popup from '@components/base/base_popup.vue'
export default {
  name: 'multipleChoiceSharingMenuRow',
  components: {
    Popup,
  },
  props: {
    baseOpt: {
      type: Object,
      default: () => ({
        openMenuWidthVw: '19.8vw', // 打开的总宽度
        closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      }),
    },
    list: {
      type: [Array, null],
      default: null,
      //   default: () => {
      //     return [
      //       {
      //         id: 'lineup',
      //         name: '首发阵容',
      //         isAct: false,
      //       },
      //       {
      //         id: 'score',
      //         name: '评分',
      //         isAct: false,
      //       },
      //     ]
      //   },
    },
  },
  data() {
    return {
      isOpenMenu: false,
      contentWidth: '40%',
      popupShow: false,
      popTitle: '',
      popOpraBtns: [],
      warningText: '',
    }
  },
  methods: {
    clickIsOpenMenu(flag) {
      this.isOpenMenu = !flag
    },
    clickMenu(item) {
      if (!this.isOpenMenu) return
      this.$emit('clickMenuEvent', item)
    },
    clickPublicTheme() {
      let isFlag = false
      let currPublicThemeItem = null
      if (this.list && this.list.length > 0) {
        this.list.forEach((item) => {
          if (item.isAct) {
            isFlag = true
            currPublicThemeItem = item
          }
        })
      }
      if (!isFlag) {
        // 没有选主题，不能分享
        this.openPopup()
        return
      }
      this.$emit('clickPublicThemeEvent', currPublicThemeItem)
    },
    // 关闭弹窗
    closePopup() {
      this.popupShow = false
      this.warningText = ''
      this.contentWidth = '40%'
    },
    openPopup() {
      this.popOpraBtns = [
        {
          btnTitle: '知道了',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【需要分享的主题】`
      this.popTitle = '提示'
      this.popupShow = true
    },
  },
}
</script>

<style lang="scss" scoped>
.multipleChoiceSharingMenuRow {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: auto;
  .menu_container {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    /* width: 6.4vw; */
    height: calc(2.2vw + 1px + 1px);
    border: 1px solid var(--mixtmt_greyColor7);
    border-radius: calc(1.1vw + 1px);
    padding: 0 1.1vw 0 2.9vw;
    transition: width 0.3s linear;
    overflow: hidden;
    &.menuIsOpenState {
      /* width: 13.88vw; */
      .menuBox_openBtn {
        transform: rotate(0deg);
      }
    }
    .menuBox_openBtn {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: -1px;
      top: -1px;
      z-index: 10;
      width: calc(2.2vw + 1px + 1px);
      height: calc(2.2vw + 1px + 1px);
      background-color: var(--mixtmt_whiteColor);
      border: 1px solid var(--mixtmt_greyColor7);
      border-radius: calc(1.1vw + 1px);
      transform: rotate(180deg);
      transition: transform 0.3s linear;
      svg {
        fill: var(--mixtmt_greyColor4);
      }
    }
    .theme_publishBtn {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 2.2vw;
      height: 2.2vw;
      svg.publishBtn_icon {
        fill: var(--mixtmt_greyColor4);
      }
    }
    .menuList {
      position: absolute;
      top: 0;
      right: 3.2vw;
      z-index: 2;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      width: auto;
      height: calc(2.2vw + 1px + 1px);
      .menuItem {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: auto;
        padding-right: 1.1vw;
        &.hideMenu {
          pointer-events: none;
        }
        .item_absChoose {
          width: 2.2vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          padding-right: 0.347vw;
          .checkbox_item {
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 50%;
            border: 1px solid var(--mixtmt_mainColor6);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            background-color: var(--mixtmt_whiteColor);
            svg {
              opacity: 0;
              fill: var(--mixtmt_whiteColor);
              transition: all 0.3s linear;
            }
          }
          &.chooseAct {
            .checkbox_item {
              background-color: var(--mixtmt_mainColor6);
              svg {
                opacity: 1;
              }
            }
          }
        }
        .menuItem_title {
          width: auto;
          font-size: 1.11vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
  }
}
.mixtmt_pc .multipleChoiceSharingMenuRow {
  .menu_container {
    .menuBox_openBtn {
      &:hover {
        background-color: var(--mixtmt_mainColor6);
        cursor: pointer;
        svg {
          fill: var(--mixtmt_whiteColor);
        }
      }
    }
    .menuList {
      .menuItem {
        &:hover {
          cursor: pointer;
          .menuItem_title {
            text-decoration: underline;
            color: var(--mixtmt_mainColor6);
          }
        }
      }
    }
    .theme_publishBtn {
      cursor: pointer;
      &:hover {
        svg.publishBtn_icon {
          fill: var(--mixtmt_mainColor6);
        }
      }
    }
  }
}

.webmaster_popup_box
  .webmaster_popup_item
  .webmaster_popup_opra
  .opraBtn:first-child {
  margin-left: 0;
  background: var(--mixtmt_whiteColor);
  border: 1px solid var(--mixtmt_greyColor7);
  color: var(--mixtmt_greyColor2);
  &:hover {
    background: var(--mixtmt_mainColor6);
  }
}
.group_popup {
  height: 100%;
  padding: 0.694vw;
  width: 90%;
  h1 {
    font-size: 1.25vw;
    color: var(--mixtmt_greyColor3);
  }
  .group_popup_wraning {
    margin: 1.388vw 0;
    font-size: 0.972vw;
    font-weight: 600;
    color: var(--mixtmt_greyColor2);
    line-height: 1.667vw;
    text-align: center;
    span {
      color: var(--mixtmt_errColor);
    }
  }
}
</style>
